import { Injectable } from '@angular/core';

import { Camera, CameraResultType, ImageOptions, CameraSource } from '@capacitor/camera';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceService } from '../device-service/device-service';
import { DeviceInfo } from '../../data/device-info';
import { Platform } from '@ionic/angular';
import { Custom_RequestMethod } from '../common-service';
import { DomSanitizer } from '@angular/platform-browser';
/*
 Generated class for the ImageService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ImageService {
  [x: string]: any;
  deviceInfo: DeviceInfo;
  constructor(
    // private camera: Camera,
    private deviceService: DeviceService,
    private platform: Platform,
    private sanitizer: DomSanitizer,
    private requestMethod: Custom_RequestMethod
  ) {
    // if(this.platform.is('capacitor')) {
    this.deviceService.getDeviceInfo().then((devInfo: DeviceInfo) => {
      this.deviceInfo = devInfo;
    });
    // }
  }

  public checkVersion() {
    let _version = '9';
    ('9.12-update');
    let _splitter;
    _splitter = _version.split('.', 1) ? _version.split('.', 1) : _version;

    if (this.deviceInfo) {
    }
  }

  /**
   * Capture an image using camera
   * Uses Android photo picker - no READ_MEDIA_IMAGES/READ_MEDIA_VIDEO permissions required
   * @param highQuality Whether to capture the high quality image.
   * @returns {Promise<any>} Photo data with dataUrl
   */
  public async captureImage(highQuality: boolean = true, encodingType: number = 0) {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Camera, // Explicitly use camera
      });
      return image;
    } catch (error) {
      console.error('Error capturing image:', error);
      throw error;
    }
  }

  /**
   * Pick an image from photo library using Android photo picker
   * No READ_MEDIA_IMAGES/READ_MEDIA_VIDEO permissions required
   * @returns {Promise<any>} Photo data with dataUrl
   */
  public async pickImage(encodingType: number = 0) {
    try {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Photos, // Use photo library/picker
      });
      return image;
    } catch (error) {
      console.error('Error picking image:', error);
      throw error;
    }
  }

  /**
   * Get the image from photo library
   * @param options The camera options
   * @returns {any}
   * @private
   */
  private _getImage(options: ImageOptions): Observable<ImageData> {
    let promise: Promise<ImageData> = null;

    // this.camera.getPicture(options)
    //                                         .then((imageUrl: string) => {
    //                                             let name     = imageUrl.substr(imageUrl.lastIndexOf('/') + 1);
    //                                             let namePath = imageUrl.substr(0, imageUrl.lastIndexOf('/') + 1);
    //                                             return {
    //                                                 originalURL: imageUrl,
    //                                                 imageName  : name,
    //                                                 imagePath  : namePath
    //                                             }
    //                                         });
    return from(promise).pipe(
      map((data: ImageData) => {
        return data;
      })
    );
  }

  dataURLtoBlob(dataUrl: string): Blob {
    const byteString = atob(dataUrl.split(',')[1]);
    const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
}

export interface ImageData {
  originalURL: string;
  imageName?: string;
  imagePath?: string;
}
